module.exports = __webpack_public_path__ + "static/media/redeem-code-active-dark-icon.c1ab0397.svg";